import CloseIcon from '@mui/icons-material/Close';
import { Chip, Stack, SxProps, Theme } from "@mui/material";
import SpriteIcon from "../../../../core-components/assets/Icon";
import { getChipStylingBasedOnIcon } from "../../helper";
import { FileTypeFilter, FileTypeFiltersProps } from "../../types";
import { getIconTypeFromMime } from '../../../../utilities/helpers';

const FileTypeFilters = ({ fileTypeFiltersCollection, handleClearAll, handleFileTypeSelection }: FileTypeFiltersProps) => {

  const renderChips = (fileTypeFilter: FileTypeFilter, index: number) => {
    const iconName = getIconTypeFromMime(fileTypeFilter?.iconType);
    let iconType = <SpriteIcon id={iconName} width="16" height="16" />
    let chipStyling: SxProps<Theme> = getChipStylingBasedOnIcon(fileTypeFilter);

    return (
      <Chip key={index} label={fileTypeFilter?.label}
        size='medium'
        sx={chipStyling}
        onClick={() => handleFileTypeSelection(index)}
        icon={iconType}
        onDelete={fileTypeFilter?.selected ? () => handleFileTypeSelection(index) : undefined}
        deleteIcon={fileTypeFilter?.selected ? <CloseIcon /> : undefined}
      />
    )
  }

  return (
    <Stack
      direction="row"
      columnGap={4}
      sx={{
        overflowX: 'auto',
        whiteSpace: 'nowrap',
      }}
    >
      {fileTypeFiltersCollection?.map((fileTypeFilter: FileTypeFilter, index: number) => {
        return renderChips(fileTypeFilter, index)
      })}
      {!!fileTypeFiltersCollection.some((filter) => filter.selected) && <Chip label={'Clear All'}
        color="Primary"
        variant='outlined'
        onClick={handleClearAll}
      />}
    </Stack>
  );
};

export default FileTypeFilters;